import {
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";
import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { ItemCategory } from "shared/types";

const CategorySelectDialog = ({
  selectedCategory,
  setSelectedCategory,
  isFetching,
  itemsPerPage,
  categories,
}: {
  selectedCategory: ItemCategory | null;
  setSelectedCategory: (value: SetStateAction<ItemCategory | null>) => void;
  isFetching: boolean;
  itemsPerPage: number;
  categories: ItemCategory[];
}) => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false); // Állapot a modális megnyitásához

  const handleCategorySelect = (category: any) => {
    setSelectedCategory(category);
    setIsDialogOpen(false); // Modális bezárása
  };

  const handleClearSelection = () => {
    setSelectedCategory(null); // Kategória kijelölésének megszüntetése
    setIsDialogOpen(false); // Modális bezárása
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setIsDialogOpen(true)} fullWidth>
        {selectedCategory?.name || t("Válasszon kategóriát")}
      </Button>
      <Dialog open={isDialogOpen} onClose={() => setIsDialogOpen(false)} fullWidth>
        <DialogTitle>
          <Typography variant="h6" style={{ marginBottom: 16 }}>
            {t("Kategóriák")}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {/* Opció a kijelölés törlésére */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Card
                onClick={handleClearSelection}
                style={{
                  height: "80px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 16,
                  cursor: "pointer",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  border: selectedCategory === null ? "2px solid blue" : "1px solid lightgray",
                }}
              >
                <Typography variant="body1" style={{ fontWeight: "bold", fontStyle: "italic" }}>
                  {t("Nincs kijelölt kategória")}
                </Typography>
              </Card>
            </Grid>
            {isFetching ? (
              Array.from({ length: itemsPerPage }).map((_, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card
                    style={{
                      height: "80px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 16,
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <Typography variant="body1">{t("Betöltés...")}</Typography>
                  </Card>
                </Grid>
              ))
            ) : categories.length === 0 ? (
              <Grid item xs={12}>
                <Typography
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "gray",
                  }}
                >
                  {t("Nincsenek kategóriák.")}
                </Typography>
              </Grid>
            ) : (
              categories.map(category => (
                <Grid item xs={12} sm={6} key={category.id}>
                  <Card
                    onClick={() => handleCategorySelect(category)}
                    style={{
                      height: "80px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: 16,
                      cursor: "pointer",
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                      border:
                        selectedCategory?.id === category.id
                          ? "2px solid blue"
                          : "1px solid lightgray",
                    }}
                  >
                    <Typography variant="body1" style={{ fontWeight: "bold" }}>
                      {category.name}
                    </Typography>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CategorySelectDialog;
